import React, { Component } from "react";
import { connect } from "react-redux";

//Actions
import * as ACTIONS from "./../../../actions/actionConstants";

//Components
import ProfileForm from "./../../../components/ProfileForm";
import { withStyles } from "@material-ui/core/styles";

//Deps
import { push } from "react-router-redux";

function mapStateToProps(state) {
  return {
    businessOptions: state.app.businessOptions,
    cUID: state.user.currentUser.cUID,
    darkMode: state.app.darkMode,

    //Default values
    defaultNotes: state.user.currentUser.profile.notes,
    defaultEmail: state.user.currentUser.profile.email,
    defaultName: state.user.currentUser.profile.name,
    defaultPhone: state.user.currentUser.profile.phone,
    defaultPosition: state.user.currentUser.profile.position,

    //Form Values
    email: state.forms.profile.email,
    name: state.forms.profile.name,
    phone: state.forms.profile.phone,

    //Form State
    pending: state.forms.forms.profile.$form.pending,
    submitted: state.forms.forms.profile.$form.submitted,
    submitFailed: state.forms.forms.profile.$form.submitFailed,
    validating: state.forms.forms.profile.$form.validating,

    emailIsValid: state.forms.forms.profile.email.valid,
    formIsValid: state.forms.forms.profile.$form.valid,

    //Errors
    emailErrors: state.forms.forms.profile.email.errors,
    formErrors: state.forms.forms.profile.$form.errors
  };
}

function mapDispatchToProps(dispatch) {
  return {
    //Routing
    routeHome: () => dispatch(push("home")),
    routeReset: () => dispatch(push("reset")),

    //Form Submit
    handleSubmit: (val, cUID, client) =>
      dispatch({
        type: ACTIONS.SUBMIT_EDIT_PROFILE,
        meta: {
          cUID,
          client,
          uUID: null,
          model: "forms.profile",
          payload: val
        }
      }),

    //Advanced Form Toggle
    handleToggle: (val, e) => {
      dispatch({
        type: ACTIONS.TOGGLE_BUSINESS_OPTIONS,
        payload: e
      });
    },

    //If already logged in
    routeToProfile: () => {
      dispatch(push("profile"));
    }
  };
}

//Styles
const styles = theme => ({
  root: {}
});

class ClientProfile extends Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <ProfileForm model="forms.profile" {...this.props} />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ClientProfile));



// WEBPACK FOOTER //
// ./src/pages/client_dashboard/account_tabs/ClientProfile.js